// TODO: Storybook entry
import React from "react";
import type { GroupBase, StylesConfig } from "react-select";
import Creatable, { type CreatableProps } from "react-select/creatable";

import { zindexModal } from "~/css/zindexes";

import {
	condensedStyles,
	DropdownIndicator,
	IndicatorSeparator,
	Option,
	outlinedStyles,
	SelectContainer,
	type SelectorOption,
	SingleValue,
} from "./SelectorUtils";

interface SelectorProps<T> extends CreatableProps<T, false, GroupBase<T>> {
	condensed?: boolean;
	selectorZIndex?: number;
	width?: string;
}

export default function Selector<T extends SelectorOption>({
	components: customComponents,
	condensed,
	isSearchable,
	menuPortalTarget,
	selectorZIndex,
	width,
	styles,
	...rest
}: SelectorProps<T>) {
	let reactSelectStyles: StylesConfig = { ...outlinedStyles, container: base => ({ ...base, width: width || "100%" }) };

	if (condensed)
		reactSelectStyles = {
			...condensedStyles,
			container: base => ({ ...base, display: "inline-block", width: width || "auto" }),
		};

	reactSelectStyles = {
		...reactSelectStyles,
		menuPortal: base => ({ ...base, zIndex: (selectorZIndex ?? zindexModal) + 1 }),
	};

	return (
		<Creatable<T, false>
			{...rest}
			components={{
				DropdownIndicator,
				IndicatorSeparator,
				Option,
				SelectContainer,
				SingleValue,
				...customComponents,
			}}
			isSearchable={isSearchable ?? false}
			menuPortalTarget={menuPortalTarget ?? document.body}
			styles={{ ...(reactSelectStyles as StylesConfig<T, false>), ...styles }}
		/>
	);
}

export { components } from "react-select";
export type { MenuProps, SingleValue, SingleValueProps, ValueContainerProps, ControlProps } from "react-select";
export type { SelectorOption, SelectorProps };
